<template>
  <section v-click-outside="onClickOutside">
    <button type="button" class="c-head__control" :class="{ 'c-head__control--expanded': isExpanded, 'u-hidden': isMobileMenuExpanded }" @click="toggleExpanded">
      <i class="u-fa u-fa-phone" :class="{ 'u-d-none': isExpanded }"></i>
      <div class="c-icon-times" :class="{ 'u-d-none': !isExpanded }"></div>
    </button>
    <div class="c-working-hours" :class="{ 'c-working-hours--expanded': isExpanded, 'c-working-hours--fluid': isFluid }" @click="toggleFluid">
      <div class="c-working-hours__summary">
        <div class="c-working-hours__phone">
          <i class="u-fa u-fa-phone"></i> <a :href="`tel:${ fullTel }`" v-text="t(shortTel)"></a>
        </div>
        <div class="c-working-hours__status" v-text="status"></div>
      </div>
      <div class="c-working-hours__timetable">
        <ul class="c-working-hours__days">
          <li class="c-working-hours__day" v-for="day in daysFormatted" :class="{ 'c-working-hours__day--current': day.today, 'u-d-none': !day.active }">
            <span v-text="day.name"></span>
            <span v-text="`${ day.from } - ${ day.to }`"></span>
          </li>
        </ul>
        <div class="c-working-hours__contact" v-html="`${ additionalInfo } <a href='mailto:${ email }'>${ email }</a>`"></div>
      </div>
    </div>
  </section>
</template>
<script lang="ts">
import moment from 'moment';
import { Component, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import BaseComponent from './Base';

const ui = namespace('ui');
const officeScheduleStore = namespace('officeSchedule');

@Component
export default class WorkingHours extends BaseComponent {
  @Prop({ type: String, required: true }) protected readonly shortTel: string;
  @Prop({ type: String, required: true }) protected readonly fullTel: string;
  @Prop({ type: String, required: false }) protected readonly email: string;
  @Prop({ type: String, default: '' }) protected readonly additionalInfo: string;
  @ui.State('mobileMenuToggled') protected readonly isMobileMenuExpanded: boolean;
  @officeScheduleStore.State('days') protected readonly days: { [dayName: string]: { active: boolean, start: number, end: number } };

  protected isExpanded: boolean = false;
  protected isFluid: boolean = false;
  private currentDayaName: string | null = null;

  protected get current(): string {
    if (this.currentDayaName === null) {
      this.currentDayaName = moment().locale('en').format('ddd').toLowerCase();
    }

    return this.currentDayaName;
  }

  protected get status(): string {
    if (!this.daysFormatted.hasOwnProperty(this.current) || !this.daysFormatted[this.current].active) {
      return this.t('Closed today');
    }

    return `${ this.t('Open today') } ${ this.daysFormatted[this.current].from } - ${ this.daysFormatted[this.current].to }`;
  }

  protected get daysFormatted(): { [dayName: string]: { active: boolean; today: boolean, name: string, from: string, to: string } } {
    const dayMappings: { [dayName: string]: number } = Object.fromEntries(Array.from({ length: 7 }, (_, i) => [moment().day(i).locale('en').format('ddd').toLowerCase(), i]));
    return Object.fromEntries(Object.entries(this.days).map(([dayName, day]) => {
      const start = moment().startOf('day').add(day.start, 'seconds');
      const end = moment().startOf('day').add(day.end, 'seconds');
      const format = (start.minutes() !== 0 || end.minutes() !== 0) ? 'HH:mm' : 'HH';

      return [dayName, {
        active: day.active,
        today: dayName === this.current,
        name: this.t(moment().day(dayMappings[dayName]).format('dddd')),
        from: start.format(format),
        to: end.format(format),
      }];
    }));
  }

  protected toggleExpanded(): void {
    if (this.isFluid) {
      return;
    }
    this.isExpanded = !this.isExpanded;
  }

  protected toggleFluid(): void {
    if (this.isExpanded) {
      return;
    }
    this.isFluid = !this.isFluid;
  }

  protected onClickOutside() {
    this.isExpanded = false;
    this.isFluid = false;
  }

}
</script>
